import React, { useState } from "react";
import { Group, Card, Divider } from "@mantine/core";
import styled from "styled-components";

import { AssetList, AssetUpload } from "./";
import { Header } from "@components/shared";

export default function AssetManagement({
  children,
  items = [],
  isIndex,
  library,
  limit = null,
  onExternalUrlUpdate = () => true,
  onRemoveSuccess = () => true,
  onRenameSuccess = () => true,
  onUploadSuccess = () => true,
  preview = null,
  reqData: entityReqData = {},
  showExternalUrl = false,
  shouldFetch = true,
  title = "Assets",
  uploadOnly = false,
}) {
  const [refresh, setRefresh] = useState(false);

  const assets = [...items];

  function onRemove(itemId) {
    onRemoveSuccess(itemId);
    setRefresh(!refresh);
  }

  const uploadReqData = { ...entityReqData };
  const listReqData = { ...entityReqData };

  if (uploadOnly) {
    return (
      <Group>
        <AssetUpload
          library={library}
          reqData={uploadReqData}
          onSuccess={(newAsset) => {
            onUploadSuccess(newAsset.id);
          }}
        />
        {children && <React.Fragment>{children}</React.Fragment>}
      </Group>
    );
  }

  return (
    <StyledAssets>
      <Group>
        {preview && <React.Fragment>{preview(assets)}</React.Fragment>}
        <Header>{title}</Header>
        {(!limit || (limit && assets.length < limit)) && (
          <AssetUpload
            library={library}
            reqData={uploadReqData}
            onSuccess={(newAsset) => {
              setRefresh(!refresh);
              onUploadSuccess(newAsset.id);
            }}
          />
        )}
        {children && <React.Fragment>{children}</React.Fragment>}
      </Group>
      <Divider mt="lg" mb="sm" />
      <Card
        style={{
          overflow: "visible",
        }}
      >
        <AssetList
          assets={assets}
          isIndex={isIndex}
          library={library}
          limit={limit}
          refresh={refresh}
          reqData={listReqData}
          shouldFetch={shouldFetch}
          variety={null}
          showExternalUrl={showExternalUrl}
          onRemoveSuccess={(itemId) => onRemove(itemId)}
          onRenameSuccess={(itemId, newName) =>
            onRenameSuccess(itemId, newName)
          }
          onExternalUrlUpdate={(itemId, newUrl) =>
            onExternalUrlUpdate(itemId, newUrl)
          }
          onRefresh={() => setRefresh(!refresh)}
        />
      </Card>
    </StyledAssets>
  );
}

const StyledAssets = styled.div`
  & + & {
    /* margin-top: 2em; */
  }
`;
